import { gql } from "@apollo/client";

export const BILLING_DETAILS_QUERY = gql`
  query Billing {
    me {
      billingDetails
    }
  }
`;
